export var letterSpacingNone = 0;
export var letterSpacingSmall = 0.2;
export var letterSpacingMedium = 0.3;
export var letterSpacingLarge = 0.4;